import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { CanActivate, ActivatedRouteSnapshot, Router } from '@angular/router';
import { PermissionService } from '../core/services/permission.service';

@Injectable({ providedIn: 'root' })
export class PermissionGuard implements CanActivate {
  constructor(
    private permissionService: PermissionService,
    private router: Router,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {}

  canActivate(route: ActivatedRouteSnapshot): boolean {
    // On server (SSR), allow navigation — the client will re-check after hydration
    if (!isPlatformBrowser(this.platformId)) {
      return true;
    }

    const pageKey = route.data['pageKey'];

    // No pageKey → allow
    if (!pageKey) return true;

    if (this.permissionService.canView(pageKey)) {
      return true;
    }

    this.router.navigate(['/unauthorized']);
    return false;
  }
}
